<template>
  <div class="contents_wrap">
    <div class="small_title_wrap">
      <h2>상세 정보[받는 분]</h2>
    </div>
    <ul class="filter_list">
      <li>
        <dd>
          <label>수신</label>
          <ul class="w50">
            <li>
              <b class="txt_b">{{ sendInfo.receiveNm }}</b>
            </li>
          </ul>
        </dd>
        <dd>
          <label>발송 수단</label>
          <ul class="w50">
            <li class="w100">
              {{ sendInfo.deliveryScnNm }}
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label>수신 연락처</label>
          <ul class="w50">
            <li>
              {{ receiveTel }}
            </li>
          </ul>
        </dd>
        <dd>
          <label>내용물</label>
          <ul class="w80">
            <li>
              {{ sendInfo.contentsScn==='03' ? `${sendInfo.contentsScnNm} (${sendInfo.contentsScnDesc})` :  sendInfo.contentsScnNm }}
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label>수신 주소</label>
          <ul class="w50">
            <li>
              {{ receiveAddrWithPostNo }}
            </li>
          </ul>
        </dd>
        <dd>
          <label>신고 금액</label>
          <ul class="w50">
            <li>
              {{ !!regCost ? regCost : '-' }}
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label>상세 주소</label>
          <ul class="w50">
            <li>
              {{ sendInfo.receiveAddrDtl === null ? '-' : sendInfo.receiveAddrDtl }}
            </li>
          </ul>
        </dd>
        <dd>
          <label>보관 위치</label>
          <ul class="w50">
            <li>
              {{ !!sendInfo.lockerNm ? sendInfo.lockerNm : '-' }}
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label>비고</label>
          <ul class="w50">
            <li>
              {{ !!sendInfo.contents ? sendInfo.contents : '-'}}
            </li>
          </ul>
        </dd>
        <dd>
          <label>무인 보관함 번호</label>
          <ul class="w50">
            <li>
              {{ !!sendInfo.lockerCellId ? sendInfo.lockerCellId : '-' }}
            </li>
          </ul>
        </dd>
      </li>
    </ul>
  </div>
</template>

<script>
import EtnersCommonUtil from "@/common/etners.common.util";
import EtnersParseUtil from "@/common/etners.parse.util";

export default {
  name: "SendDetailDeli",
  props: {
    sendInfo : {
      type : Object,
      required : false,
      default : function (){
        return {}
      }
    },
  },
  computed: {
    receiveAddrWithPostNo () {
      const vm = this

      const receivePost = vm.sendInfo.receivePost
      const receiveAddr = vm.sendInfo.receiveAddr

      if(receivePost !== null && receiveAddr !== null){
        return `(${receivePost}) ${receiveAddr}`
      }else{
        return ''
      }
    },

    regCost () {
      return EtnersCommonUtil.numberWithCommas(this.sendInfo.regCost)
    },

    receiveTel () {
      return EtnersParseUtil.convertTelNo(this.sendInfo.receiveTel)
    }
  },
}
</script>

<style scoped>

</style>